import { assertProfileAvailable } from '../../Common/profileAvailability';
import { Autocomplete, TextField } from '@mui/material';
import { get, ref, remove, set, update } from 'firebase/database';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { database } from '../../Common/Firebase';

import '../ModalMaterial/style.scss';
import { throwErrorRollbar } from '../../index';
import { departmentsArr } from '../CreateStudentModal/utils';

const EditTeacherModal = ({ open, setOpen, submit, teacher, fetchTeacherView }) => {
  const { t } = useTranslation();
  const [lastName, setLastName] = useState(teacher ? teacher.lastName : '');
  const [firstName, setFirstName] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState(teacher ? teacher.email : '');
  const [branch, setBranch] = useState(teacher ? teacher.branch : '');
  const [phone, setPhone] = useState(teacher ? teacher.phone : '');
  const [lastNameDirty, setLastNameDirty] = useState(false);
  const [lastNameError, setLastNameError] = useState('');
  const [firstNameDirty, setFirstNameDirty] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');
  const [patronymicDirty, setPatronymicDirty] = useState(false);
  const [patronymicError, setPatronymicError] = useState('');
  const [emailDirty, setEmailDirty] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [phoneDirty, setPhoneDirty] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [cityDirty, setCityDirty] = useState(false);
  const [cityError, setCityError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  const navigate = useNavigate();

  const lastNameHandler = e => {
    const value = e.target.value;
    setLastNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setLastNameError(t('field is required'));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setLastNameError(t('Last name must start with a capital letter and contain only letters'));
    } else {
      setLastNameError('');
    }
  };

  const firstNameHandler = e => {
    const value = e.target.value;
    setFirstNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setFirstNameError(t(''));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setFirstNameError(t('First name must start with a capital letter and contain only letters'));
    } else {
      setFirstNameError('');
    }
  };

  const patronymicHandler = e => {
    const value = e.target.value;
    setPatronymicDirty(true);

    if (value === undefined || value.trim() === '') {
      setPatronymicError(t(''));
    } else if (!/^(?!.*['`]{2})(?!.*['`].*['`])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ']*)$/.test(value.trim())) {
      setPatronymicError(t('Patronymic must start with a capital letter and contain only letters'));
    } else {
      setPatronymicError('');
    }
  };

  const emailHandler = e => {
    const value = e.target.value;
    const re =
      /^(([a-z0-9]{1}[-0-9a-z\.]{1,}[0-9a-z]{1})|([0-9]{1}[-0-9a-z\.]{1,}[0-9]{1}))@([-0-9a-z]{1,}\.){1,2}[-a-z]{2,}$/u;

    setEmail(value);

    if (value === undefined || value.trim() === '') {
      setEmailError(t('field is required'));
    } else if (!re.test(String(value).toLocaleLowerCase())) {
      setEmailError(t('Wrong email address format'));
    } else {
      setEmailError('');
    }
  };

  const phoneHandler = e => {
    const value = e.target.value;
    setPhoneDirty(true);

    if (value.trim() === '') {
      setPhoneError('');
    } else if (!/^\+380\d{9}$/.test(value.trim())) {
      setPhoneError(t('Phone number can only be a number'));
    } else {
      setPhoneError('');
    }
  };

  const cityHandler = e => {
    const value = e.target.value;
    setCityDirty(true);

    if (value === undefined || value.trim() === '') {
      setCityError(t(''));
    } else if (
      !/^(?!.*['`]{2})(?!.*['`].*['`])(?!.*[-`]{2})(?!.*[-`].*[-`])(?!.*[ `]{2})(?!.*[ `].*[ `])([A-Z][a-z]*|[А-ЯЁЇІЄҐ][а-яёїієґ'\s-]*)$/.test(
        value.trim(),
      )
    ) {
      setCityError(t('The name of the city must consist only of letters and begin with a capital letter'));
    } else {
      setCityError('');
    }
  };

  const blurHandler = e => {
    switch (e.target.name) {
      case 'lastName':
        setLastNameDirty(true);
        if (value === undefined || value.trim() === '') {
          setLastNameError(t('field is required'));
        } else {
          setLastNameError('');
        }
        break;

      case 'firstName':
        setFirstNameDirty(true);
        if (value === undefined || value.trim() === '') {
          setFirstNameError(t('field is required'));
        } else {
          setFirstNameError('');
        }
        break;

      case 'email':
        setEmailDirty(true);
        if (value === undefined || value.trim() === '') {
          setLastNameError(t('field is required'));
        } else {
          setLastNameError('');
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (lastNameError || firstNameError || patronymicError || emailError || phoneError || cityError) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  }, [lastNameError, firstNameError, patronymicError, emailError, phoneError, cityError]);

  const nameInitials = (lastName, firstName, patronymic) => {
    let initials = `${lastName.charAt(0).toUpperCase()}${lastName.slice(1)} ${firstName.charAt(0).toUpperCase()}.`;

    if (patronymic) {
      initials += ` ${patronymic.charAt(0).toUpperCase()}.`;
    }

    return initials;
  };

  const onSubmitFunc = async () => {
    let profileAddress;
    try {
      profileAddress = await assertProfileAvailable(email, 'Teachers', teacher?.email?.replace(/\./g, ''),
        path => get(ref(database, path)));
    } catch (error) {
      setEmailError(error.message || 'Не вдалося перевірити профілі. Спробуйте ще раз.');
      return;
    }
    const id = profileAddress.key;
    const initials = nameInitials(lastName, firstName, patronymic);
    const oldEmail = teacher.email;
    const newEmail = profileAddress.email;
    const oldId = oldEmail.replace(/\./g, '');
    const newId = newEmail.replace(/\./g, '');

    if (oldId !== newId) {
      const oldRefTeacher = ref(database, `Teachers/${oldId}`);
      const newRefTeacher = ref(database, `Teachers/${newId}`);

      try {
        const snapshot = await get(oldRefTeacher);

        if (snapshot.exists()) {
          await set(newRefTeacher, snapshot.val());
          await remove(oldRefTeacher);

          navigate(`/teacherView/${newId}`);
          location.reload();
        } else {
          throw new Error(`Record with id ${id} does not exist`);
        }
      } catch (error) {
        console.log(error);
        throwErrorRollbar(error);
        return;
      }
    }

    try {
      await update(ref(database, `Teachers/${id}`), {
        FIO: initials,
        lastName: lastName,
        firstName: firstName,
        patronymic: patronymic,
        phone: phone,
        city: city,
        email: profileAddress.email,
        branch: branch,
      });

      fetchTeacherView();
      setOpen(false);
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  return (
    <div
      className={open ? 'modal-form modal-form--open' : 'modal-form'}
      onMouseDown={e => {
        setOpen(false);
        e.stopPropagation();
      }}
    >
      <div
        className="modal-form-content"
        onMouseDown={e => {
          e.stopPropagation();
        }}
      >
        <form>
          <div className="modal-header">
            <h2>{t('update teacher')}:</h2>
            <button
              className="btn btn-icon"
              onClick={e => {
                setOpen(false);
                e.preventDefault();
              }}
            >
              <span className="icon icon-plus"></span>
            </button>
          </div>

          <div className="modal-body" id="modal-body">
            <div className="form-control autocomplete-control">
              <Autocomplete
                id="lastName"
                options={[]}
                value={teacher ? teacher.lastName : ''}
                onInputChange={(e, v) => setLastName(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('lastName')}
                    value={teacher.lastName}
                    onChange={lastNameHandler}
                    name="lastName"
                    placeholder=" "
                  />
                )}
              />
              {lastNameDirty && lastNameError && <span className="error">{lastNameError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="firstName"
                options={[]}
                value={teacher ? teacher.firstName : ''}
                onInputChange={(e, v) => setFirstName(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('firstName')}
                    value={teacher.firstName}
                    onChange={firstNameHandler}
                    name="firstName"
                    placeholder=" "
                  />
                )}
              />
              {firstNameDirty && firstNameError && <span className="error">{firstNameError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="patronymic"
                options={[]}
                value={teacher ? teacher.patronymic : ''}
                onInputChange={(e, v) => setPatronymic(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('patronymic')}
                    value={teacher.patronymic}
                    onChange={patronymicHandler}
                    placeholder=" "
                  />
                )}
              />
              {patronymicDirty && patronymicError && <span className="error">{patronymicError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="email"
                options={[]}
                value={teacher ? teacher.email : ''}
                onInputChange={(e, v) => setEmail(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('email')}
                    value={teacher.email}
                    onChange={emailHandler}
                    name="email"
                    placeholder=" "
                  />
                )}
              />
              {emailDirty && emailError && <span className="error">{emailError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="phone"
                options={[]}
                value={teacher ? teacher.phone : ''}
                onInputChange={(e, v) => setPhone(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('phoneNumber')}
                    value={teacher.phone}
                    onChange={phoneHandler}
                    placeholder=" "
                  />
                )}
              />
              {phoneDirty && phoneError && <span className="error">{phoneError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="city"
                options={[]}
                value={teacher ? teacher.city : ''}
                onInputChange={(e, v) => setCity(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('city')}
                    value={teacher.city}
                    onChange={cityHandler}
                    name="city"
                    placeholder=" "
                  />
                )}
              />
              {cityDirty && cityError && <span className="error">{cityError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="branch"
                options={departmentsArr}
                value={branch}
                onInputChange={(e, v) => setBranch(v)}
                renderInput={params => (
                  <TextField {...params} label={t('branch')} value={teacher.branch} placeholder=" " />
                )}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-primary more btn-active"
              onClick={e => {
                onSubmitFunc();
                e.preventDefault();
              }}
              disabled={!isFormValid}
            >
              {submit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTeacherModal;
